import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/_Common/_Services/user.service';

@Component({
    selector: 'mt-offerstatus-dialog',
    templateUrl: './offerstatus-dialog.component.html',
    styleUrls: ['./offerstatus-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OfferstatusDialogComponent implements OnInit {
  selected: any;
  recordsArray: any = [];
  paymentStatus: any;
  toBeUpdatedRecord: any = [];
  statusValues = [
    {
      id: 1,
      value: 'due',
      text: 'Due'
    },
    {
      id: 2,
      value: 'paid',
      text: 'Paid'
    },
    {
      id: 3,
      value: 'partial_paid',
      text: 'Partial paid'
    },
    {
      id: 4,
      value: 'failed',
      text: 'Failed'
    }
  ];

  constructor(
    private userService: UserService,
    public dialogRef: MatDialogRef<OfferstatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit(): void {
    this.fetchAmountPaid();
  }

  fetchAmountPaid() {
    this.userService
      .postApiCall('/api/viewData/getDueAmountPaids', {
        dueDate: this.data[0]['paymentDate'],
        DueId: this.data[1],
        offerDetailId:this.data[2]
      })
      .subscribe(res => {
        res.data.forEach(el => {
          let recordObject: any = {};
          recordObject.paymentDate = el.paymentDate;
          recordObject.totalPaid = el.totalPaid;
          recordObject.referenceNo = el.paymentReferenceNo;
          recordObject.amountPaidId = el.id;
          this.recordsArray.push(recordObject);
        });
      });
  }
  getSelectedStatus(id) {
    this.paymentStatus = id;
  }
  getSelectedRecord(id) {
    this.recordsArray.filter(el => {
      if (el.amountPaidId === id) {
        this.toBeUpdatedRecord = el;
      }
    });
  }
  updatePaymentStatus() {
    this.userService
      .postApiCall('/api/offers/updatePaymentStatus', {
        DueId: this.data[1],
        OfferDetailId: this.data[2],
        emiNo: this.data[0].emiNo,
        paymentStatus: this.paymentStatus,
        amountPaidId: this.toBeUpdatedRecord.amountPaidId
      })
      .subscribe(res => {
        if (res.resultShort === 'success') {
          this.userService.notify(res.resultLong, res.resultShort);
        } else {
          this.userService.notify(res.resultLong, res.resultShort);
        }
        setTimeout(() => {
          location.reload();
        }, 2000);
      });
  }
}
